export function getTravelAreaRegionsFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const result = [];

    // ?travelAreaRegion=123 or ?travelAreaRegion=123,456
    const direct = params.get('travelAreaRegion');
    if (direct) {
        direct
        .split(',')
        .map(v => parseInt(v, 10))
        .filter(Number.isFinite)
        .forEach(v => result.push(v));
    }

    // ?travelAreaRegion[0]=123&travelAreaRegion[1]=456
    params.forEach((value, key) => {
        const match = key.match(/^travelAreaRegion\[(\d+)\]$/);
        if (match) {
            const n = parseInt(value, 10);
            if (Number.isFinite(n)) {
                result.push(n);
            }
        }
    });

    return [...new Set(result)];
}

export function getTravelAreaCountriesFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const result = [];

    // ?travelAreaCountry=16790 or ?travelAreaCountry=16790,17866
    const direct = params.get('travelAreaCountry');
    if (direct) {
        direct
        .split(',')
        .map(v => parseInt(v, 10))
        .filter(Number.isFinite)
        .forEach(v => result.push(v));
    }

    // ?travelAreaCountry[0]=17003&travelAreaCountry[1]=17866
    params.forEach((value, key) => {
        const match = key.match(/^travelAreaCountry\[(\d+)\]$/);
        if (match) {
            const n = parseInt(value, 10);
            if (Number.isFinite(n)) {
                result.push(n);
            }
        }
    });

    // remove duplicates
    return [...new Set(result)];
}

export function calculateFixedTravelAreaLevel(filter) {
    let count = 0;

    if (filter.travelAreaCountry.length > 0) {
        count++;
    }
    if (Array.isArray(filter.travelAreaRegion) ? filter.travelAreaRegion.length > 0 : filter.travelAreaRegion !== 0) {
        count++;
    }
    if (filter.travelAreaDestination !== 0) {
        count++;
    }

    return count;
}

export function constructSelectedOptionsFromUid(travelAreaCountriesUid, travelAreaUid, countries, regions, destinations) {

    const response = {
        selectedCountry: [],
        selectedRegion: [],
        selectedDestination: 0
    };

    if (travelAreaCountriesUid.length > 0) {
        response.selectedCountry = travelAreaCountriesUid.filter(uid => {
            return countries.find(country => country.uid === uid)
        })
        return response;
    } else {

        if (countries && regions && destinations) {
            if (countries.find(country => country.uid === travelAreaUid)) {
                response.selectedCountry = [travelAreaUid];
            }

            else if (regions.find(region => region.uid === travelAreaUid)) {
                const selectedRegion = regions.find(region => region.uid === travelAreaUid);
                let selectedCountry = [];
                selectedRegion.parents.forEach((parent) => {
                    const tempCountry = countries.find(country => country.uid === parent);
                    if (tempCountry) {
                        selectedCountry = tempCountry;
                    }
                });
                response.selectedRegion = [selectedRegion.uid];
                response.selectedCountry = [selectedCountry.uid];
            }

            else if (destinations.find(destination => destination.uid === travelAreaUid)) {
                const selectedDestination = destinations.find(region => region.uid === travelAreaUid);
                let selectedRegion = {};
                selectedDestination.parents.forEach((parent) => {
                    const tempRegion = regions.find(region => region.uid === parent);
                    if (tempRegion) {
                        selectedRegion = tempRegion;
                    }
                });

                let selectedCountry = [];
                if (selectedRegion.parents) {
                    selectedRegion.parents.forEach((parent) => {
                        const tempCountry = countries.find(country => country.uid === parent);
                        if (tempCountry) {
                            selectedCountry = tempCountry;
                        }
                    });
                    response.selectedDestination = selectedDestination.uid;
                    response.selectedRegion = [selectedRegion.uid];
                    response.selectedCountry = [selectedCountry.uid];
                }
            }
        }
    }

    return response;
}

export function evaluateMostSpecificSelection(selectedCountry, selectedRegion, selectedDestination) {
    if (selectedDestination > 0) {
        return selectedDestination;
    } else if (Array.isArray(selectedRegion) ? selectedRegion.length > 0 : selectedRegion > 0) {
        return Array.isArray(selectedRegion) ? selectedRegion.join(',') : selectedRegion;
    } else if (selectedCountry > 0) {
        return selectedCountry;
    } else if (typeof(selectedCountry) !== 'undefined' && selectedCountry.length > 0) { // country is multiselect in the excursion planner
        return selectedCountry.join(',')
    } else {
        return '';
    }
}



// WEBPACK FOOTER //
// ./src/services/travelAreaSelection.js